<button type="submit" class="button is-primary add {{Class}}" (click)="Clicked($event)">
  <span class="icon-text">
    <span class="icon" [ngStyle]="{'margin-top' : Class == 'is-small' ? '4px' : '0px'}"> 
      <i class="fa fa-{{Icon}}"></i>
    </span>
    <span>{{ButtonText}}</span>
  </span>
</button>